import type { DiTypes } from "@iot-platform/core";

export const userTypes = Object.seal({
    repositories: {
        UserRepository: Symbol.for("UserRepository"),
    },
} satisfies DiTypes);
